import {
  CalendarMonth,
  Email,
  Link,
  Person,
  PersonOutline,
  Phone,
  Work,
  Money,
  Edit,
  PlayArrow,
  Pause,
  DeleteOutline,
  Menu,
  EditOutlined,
  ArchiveOutlined,
  MoneyOff,
  PaidOutlined,
  Add,
  NavigateBefore,
  NavigateNext,
  ArrowDropDown,
  WorkHistory,
  VisibilityRounded,
  Download,
  Clear,
  Sailing,
  MedicalServices,
  Info,
  Houseboat,
  Medication,
  CheckCircleOutline,
  HighlightOff,
  UnarchiveOutlined,
  Block,
} from '@mui/icons-material';

import { IconsNamesMapType } from './types';

export const IconsMap: IconsNamesMapType = {
  calendarMonth: CalendarMonth,
  email: Email,
  link: Link,
  person: Person,
  personOutline: PersonOutline,
  phone: Phone,
  work: Work,
  money: Money,
  edit: Edit,
  playArrow: PlayArrow,
  pause: Pause,
  deleteOutline: DeleteOutline,
  menu: Menu,
  editOutlined: EditOutlined,
  archiveOutlined: ArchiveOutlined,
  unarchiveOutlined: UnarchiveOutlined,
  moneyOff: MoneyOff,
  paidOutlined: PaidOutlined,
  add: Add,
  navigateBefore: NavigateBefore,
  navigateNext: NavigateNext,
  arrowDropDown: ArrowDropDown,
  upWork: WorkHistory,
  watch: VisibilityRounded,
  download: Download,
  clear: Clear,
  sailing: Sailing,
  medicalServices: MedicalServices,
  info: Info,
  houseboat: Houseboat,
  medication: Medication,
  checkCircle: CheckCircleOutline,
  highlightOff: HighlightOff,
  block: Block,
};
